export enum ShopEvents {
  OPEN = 'shop_open',
  CLOSE_AT_FRONTEND = 'shop_close_at_frontend',
  BUY_ITEM = 'buy_item',
  UPGRADE_ITEM = 'upgrade_item',
}

// other methods of opening the shop exists in playcanvas. That is why method parameter is needed
export enum ShopOpenMethods {
  TAB = 'tab',
}
